(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bhakta-1898-landing"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.b1898-approved').forEach((section)=>{const items=section.querySelectorAll('.reveal');if(window.matchMedia('(prefers-reduced-motion: reduce)').matches||!('IntersectionObserver'in window)){items.forEach((item)=>item.classList.add('visible'));return}const observer=new IntersectionObserver((entries)=>{entries.forEach((entry)=>{if(entry.isIntersecting){entry.target.classList.add('visible');observer.unobserve(entry.target)}})},{threshold:.1});items.forEach((item)=>observer.observe(item))});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bhakta-article"]) return;
  try {
    
  /*
   * Copy-link button. navigator.clipboard needs a secure context, so the button
   * removes itself when the API is missing rather than failing on click.
   */
  class BhaktaShare extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-bk-copy]');
      if (!this.button) return;

      if (!navigator.clipboard) {
        this.button.hidden = true;
        return;
      }

      this.original = this.button.textContent.trim();
      this.button.addEventListener('click', () => this.copy());
    }

    async copy() {
      try {
        await navigator.clipboard.writeText(this.dataset.url);
      } catch (error) {
        return;
      }

      this.button.textContent = this.dataset.copied;
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.button.textContent = this.original;
      }, 2000);
    }
  }

  if (!customElements.get('bhakta-share')) {
    customElements.define('bhakta-share', BhaktaShare);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bhakta-awards"] && !Shopify.designMode) return;
  try {
    
  class BhaktaAwards extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('[data-bk-record-rail]');
      this.clear = this.querySelector('[data-bk-record-clear]');
      this.empty = this.querySelector('[data-bk-record-empty]');
      this.cards = Array.from(this.querySelectorAll('[data-bk-award]'));
      this.sections = Array.from(this.querySelectorAll('[data-bk-record-section]'));
      this.collectionBoxes = Array.from(this.querySelectorAll('[data-bk-record-collection]'));
      this.scoreBoxes = Array.from(this.querySelectorAll('[data-bk-record-score]'));

      // Without the script the rail is dead weight, so it only appears here.
      if (this.rail) this.rail.hidden = false;

      this.collectionBoxes.concat(this.scoreBoxes).forEach((box) => {
        box.addEventListener('change', () => this.apply());
      });

      if (this.clear) {
        this.clear.addEventListener('click', () => {
          this.collectionBoxes.concat(this.scoreBoxes).forEach((box) => {
            box.checked = false;
          });
          this.apply();
        });
      }

      this.apply();
    }

    apply() {
      const groups = this.collectionBoxes.filter((box) => box.checked).map((box) => box.value);
      const scores = this.scoreBoxes.filter((box) => box.checked);
      let shown = 0;

      this.cards.forEach((card) => {
        const inGroup = groups.length === 0 || groups.indexOf(card.dataset.group) > -1;
        const visible = inGroup && this.matchesScore(card, scores);
        card.hidden = !visible;
        if (visible) shown += 1;
      });

      /*
       * A group's count is what the filters left in it, so it is written here
       * rather than in Liquid — and a group filtered down to nothing is taken
       * off the page instead of standing as an empty heading.
       */
      this.sections.forEach((group) => {
        const left = Array.from(group.querySelectorAll('[data-bk-award]')).filter((card) => !card.hidden).length;
        const count = group.querySelector('[data-bk-record-count]');
        if (count) count.textContent = left === 1 ? '1 Award' : left + ' Awards';
        group.hidden = left === 0;
      });

      if (this.empty) this.empty.hidden = shown > 0;
      if (this.clear) this.clear.hidden = groups.length === 0 && scores.length === 0;
    }

    /*
     * Score filters are an OR set: a medal passes if it satisfies any checked
     * band. An honour with no points — Distillery of the Year — carries no
     * score, so it answers only to the honours box.
     */
    matchesScore(card, scores) {
      if (!scores.length) return true;

      const score = card.dataset.score ? Number(card.dataset.score) : null;
      const honour = card.dataset.honour === 'true';

      return scores.some((box) => {
        if (box.dataset.honour === 'true') return honour;
        if (score === null) return false;
        const min = box.dataset.min ? Number(box.dataset.min) : null;
        const max = box.dataset.max ? Number(box.dataset.max) : null;
        if (min !== null && score < min) return false;
        if (max !== null && score > max) return false;
        return true;
      });
    }
  }

  if (!customElements.get('bhakta-record')) {
    customElements.define('bhakta-record', BhaktaAwards);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bhakta-collection-library"]) return;
  try {
    
  class BhaktaLibrary extends HTMLElement {
    connectedCallback() {
      // Native filters: submit on change so there is no Apply button, and fall
      // back to the noscript submit when JS is unavailable.
      this.querySelectorAll('[data-bk-scroll]').forEach((button) => {
        button.addEventListener('click', () => {
          const row = this.querySelector('#' + button.dataset.target);
          if (!row) return;
          const step = row.clientWidth * 0.8;
          row.scrollBy({ left: button.dataset.bkScroll === 'next' ? step : -step, behavior: 'smooth' });
        });
      });

      this.initScrollSpy();
      this.initGhostReveal();

      this.initFacets();

      const form = this.querySelector('#bk-lib-filters');
      if (form) {
        form.addEventListener('change', (event) => {
          // Year boxes filter locally; everything else is a real storefront filter.
          if (event.target.hasAttribute('data-bk-facet')) return;
          form.submit();
        });
      }
    }

    initFacets() {
      this.facetBoxes = Array.from(this.querySelectorAll('[data-bk-facet]'));
      if (!this.facetBoxes.length) return;
      this.facetBoxes.forEach((box) => box.addEventListener('change', () => this.applyFacets()));
    }

    applyFacets() {
      // OR within a facet, AND across facets.
      const selected = {};
      this.facetBoxes.forEach((box) => {
        if (!box.checked) return;
        const key = box.dataset.bkFacet;
        (selected[key] = selected[key] || []).push(box.value);
      });
      const keys = Object.keys(selected);

      this.querySelectorAll('.bk-card').forEach((card) => {
        const show = keys.every((key) => {
          const attr = card.dataset['bk' + key[0].toUpperCase() + key.slice(1)] || '';
          // attr is pipe-delimited, so a product in two categories matches either.
          return selected[key].some((value) => attr.includes('|' + value + '|'));
        });
        card.classList.toggle('is-hidden', !show);
      });

      // A decade group with nothing left would be an empty heading and numeral.
      this.querySelectorAll('.bk-libgroup').forEach((group) => {
        const all = group.querySelectorAll('.bk-card');
        if (!all.length) return;
        const visible = group.querySelectorAll('.bk-card:not(.is-hidden)').length;
        group.classList.toggle('is-hidden', visible === 0);
      });
    }

    initGhostReveal() {
      const groups = Array.from(this.querySelectorAll('.bk-libgroup'));
      if (!groups.length) return;

      // No observer support, or reduced motion: show everything immediately.
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduced || !('IntersectionObserver' in window)) {
        groups.forEach((group) => group.classList.add('is-revealed'));
        return;
      }

      // Toggle rather than unobserve, so scrolling back replays the sequence.
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            entry.target.classList.toggle('is-revealed', entry.isIntersecting);
          });
        },
        { rootMargin: '0px 0px -15% 0px' }
      );

      groups.forEach((group) => observer.observe(group));
    }

    initScrollSpy() {
      const links = Array.from(this.querySelectorAll('.bk-lib__decnav-link'));
      const groups = Array.from(this.querySelectorAll('.bk-libgroup'));
      if (!links.length || !groups.length || !('IntersectionObserver' in window)) return;

      const mark = (id) => {
        links.forEach((link) => {
          link.classList.toggle('is-current', link.getAttribute('href') === '#' + id);
        });
      };

      const observer = new IntersectionObserver(
        (entries) => {
          const visible = entries
            .filter((entry) => entry.isIntersecting)
            .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top)[0];
          if (visible) mark(visible.target.id);
        },
        { rootMargin: '-20% 0px -70% 0px' }
      );

      groups.forEach((group) => observer.observe(group));
      mark(groups[0].id);
    }

  }

  if (!customElements.get('bhakta-library')) {
    customElements.define('bhakta-library', BhaktaLibrary);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bhakta-header"]) return;
  try {
    
  class BhaktaHeader extends HTMLElement {
    connectedCallback() {
      this.bar = this.querySelector('[data-bk-bar]');
      this.publishHeight();
      this.onResize = () => this.publishHeight();
      window.addEventListener('resize', this.onResize);
      if ('ResizeObserver' in window && this.bar) {
        this.resizeObserver = new ResizeObserver(() => this.publishHeight());
        this.resizeObserver.observe(this.bar);
      }

      this.honourHash();

      this.triggers = Array.from(this.querySelectorAll('[data-bk-mega-trigger]'));
      this.burger = this.querySelector('[data-bk-burger]');
      this.mobileNav = this.querySelector('[data-bk-mobile-nav]');
      this.mobilePanel = this.querySelector('[data-bk-mobile-panel]');

      this.triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => this.toggleMega(trigger));
      });

      this.searchToggle = this.querySelector('[data-bk-search-toggle]');
      this.searchPanel = this.querySelector('[data-bk-search-panel]');
      this.searchField = this.querySelector('[data-bk-search-field]');
      this.searchResults = this.querySelector('[data-bk-search-results]');
      this.searchStatus = this.querySelector('[data-bk-search-status]');
      this.searchRows = [];
      this.searchActive = -1;

      if (this.searchToggle && this.searchPanel) {
        this.searchToggle.addEventListener('click', () => {
          if (this.searchOpen()) this.closeSearch();
          else this.openSearch();
        });

        this.searchPanel.addEventListener('click', (event) => {
          if (event.target.closest('[data-bk-search-close]')) this.closeSearch();
        });

        if (this.searchField) {
          this.searchField.addEventListener('input', () => this.suggest());
          this.searchField.addEventListener('keydown', (event) => this.onSearchKey(event));
        }
      }

      if (this.burger && this.mobileNav) {
        this.burger.addEventListener('click', () => {
          if (this.mobileOpen()) this.closeMobile();
          else this.openMobile();
        });

        this.mobileNav.addEventListener('click', (event) => {
          if (event.target.closest('[data-bk-mobile-close]')) {
            this.closeMobile();
            return;
          }

          /*
           * The cart row hands the screen to the cart drawer, which sets its own
           * scroll lock in the same click. Releasing ours after that would leave
           * the page behind the cart scrollable, so the drawer closes with the
           * lock left in place.
           */
          if (event.target.closest('[data-bk-cart-open]')) this.closeMobile(false);
        });

        /*
         * Widening past the breakpoint hides the burger, so a drawer left open
         * would be stranded — unclosable, and holding the scroll lock.
         */
        this.desktop = window.matchMedia('(min-width: 1100px)');
        this.onBreakpoint = (event) => {
          if (event.matches && this.mobileOpen()) this.closeMobile();
        };
        this.desktop.addEventListener('change', this.onBreakpoint);
      }

      this.querySelectorAll('[data-bk-mobile-toggle]').forEach((toggle) => {
        toggle.addEventListener('click', () => {
          const panel = this.querySelector('#' + toggle.getAttribute('aria-controls'));
          if (!panel) return;
          const open = toggle.getAttribute('aria-expanded') === 'true';
          toggle.setAttribute('aria-expanded', String(!open));
          panel.hidden = open;
          const sign = toggle.querySelector('.bk-mnav__sign');
          if (sign) sign.textContent = open ? '+' : '−';
        });
      });

      this.onDocumentClick = (event) => {
        if (this.contains(event.target)) return;
        this.closeMega();
        this.closeSearch(false);
      };
      this.onKeydown = (event) => {
        if (event.key === 'Escape') {
          this.closeMega();
          if (this.searchOpen()) this.closeSearch();
          if (this.mobileOpen()) this.closeMobile();
          return;
        }
        if (event.key === 'Tab') this.trapMobile(event);
      };
      document.addEventListener('click', this.onDocumentClick);
      this.addEventListener('keydown', this.onKeydown);
    }

    disconnectedCallback() {
      clearTimeout(this.suggestTimer);
      if (this.suggestAbort) this.suggestAbort.abort();
      document.removeEventListener('click', this.onDocumentClick);
      this.removeEventListener('keydown', this.onKeydown);
      window.removeEventListener('resize', this.onResize);
      if (this.resizeObserver) this.resizeObserver.disconnect();
      if (this.desktop) this.desktop.removeEventListener('change', this.onBreakpoint);
      // A section re-render mid-drawer must not leave the page locked.
      if (this.mobileOpen()) document.body.style.overflow = '';
    }

    /*
     * Anchor links must land flush under the header, so the offset has to be its
     * measured height — not a guessed constant. Announcement bar on or off, and
     * every breakpoint, change it.
     */
    /*
     * Opening /pages/…#values directly should land on that band, and does not
     * on its own. Two things take the browser's native jump away: the age gate
     * sets overflow:hidden while the page loads, so the jump is discarded and
     * the reader is at the top when the gate closes; and the header has not
     * measured itself yet when the jump happens, so even an unblocked one lands
     * at the wrong offset.
     *
     * So the jump is repeated once the page can actually scroll. scroll-margin
     * does the positioning, the same as for a click.
     */
    honourHash() {
      const jump = () => {
        const id = window.location.hash.slice(1);
        if (!id) return false;
        const target = document.getElementById(decodeURIComponent(id));
        if (!target) return false;
        target.scrollIntoView();
        return true;
      };

      if (!window.location.hash) return;

      /* After layout, so the measured header height is already published. */
      requestAnimationFrame(() => requestAnimationFrame(jump));

      /* And again when the age gate lets go of the scroll. */
      const root = document.documentElement;
      if (!root.classList.contains('bk-agegate-open')) return;
      const watcher = new MutationObserver(() => {
        if (root.classList.contains('bk-agegate-open')) return;
        watcher.disconnect();
        requestAnimationFrame(() => requestAnimationFrame(jump));
      });
      watcher.observe(root, { attributes: true, attributeFilter: ['class'] });
    }

    publishHeight() {
      if (!this.bar) return;
      const height = Math.round(this.bar.getBoundingClientRect().height);
      if (!height) return;
      document.documentElement.style.setProperty('--bk-header-height', height + 'px');
    }

    toggleMega(trigger) {
      const panel = this.querySelector('#' + trigger.getAttribute('aria-controls'));
      const isOpen = trigger.getAttribute('aria-expanded') === 'true';
      this.closeMega();
      this.closeSearch(false);
      if (isOpen || !panel) return;
      trigger.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
      const sign = trigger.querySelector('.bk-nav__sign');
      if (sign) sign.textContent = '−';
    }

    closeMega() {
      this.triggers.forEach((trigger) => {
        trigger.setAttribute('aria-expanded', 'false');
        const sign = trigger.querySelector('.bk-nav__sign');
        if (sign) sign.textContent = '+';
      });
      this.querySelectorAll('[data-bk-mega]').forEach((panel) => {
        panel.hidden = true;
      });
    }

    searchOpen() {
      return !!this.searchPanel && !this.searchPanel.hidden;
    }

    openSearch() {
      this.closeMega();
      this.searchPanel.hidden = false;
      this.searchToggle.setAttribute('aria-expanded', 'true');

      // A frame between unhiding and focus, or Safari drops the caret.
      requestAnimationFrame(() => {
        if (this.searchField) this.searchField.focus();
      });
    }

    /*
     * An outside click closes the panel but must not yank focus back to the
     * toggle — the click has already put focus where the visitor wanted it.
     */
    closeSearch(restoreFocus = true) {
      if (!this.searchOpen()) return;
      clearTimeout(this.suggestTimer);
      if (this.suggestAbort) this.suggestAbort.abort();
      this.searchPanel.hidden = true;
      this.searchToggle.setAttribute('aria-expanded', 'false');
      this.clearSuggestions();
      if (restoreFocus && document.contains(this.searchToggle)) this.searchToggle.focus();
    }

    clearSuggestions() {
      if (!this.searchResults) return;
      this.searchResults.replaceChildren();
      this.searchResults.hidden = true;
      this.searchRows = [];
      this.searchActive = -1;
      if (this.searchField) {
        this.searchField.setAttribute('aria-expanded', 'false');
        this.searchField.removeAttribute('aria-activedescendant');
      }
    }

    /*
     * Suggestions come from Shopify's predictive search JSON rather than its
     * rendered section, so the rows below are BHAKTA's markup. One request is
     * in flight at a time: the previous one is aborted, since an earlier query
     * that resolves late would otherwise overwrite a newer one's results.
     */
    suggest() {
      if (!this.searchField || !this.searchResults) return;
      const term = this.searchField.value.trim();
      clearTimeout(this.suggestTimer);
      if (this.suggestAbort) this.suggestAbort.abort();

      if (term.length < 2) {
        this.clearSuggestions();
        return;
      }

      this.suggestTimer = setTimeout(() => {
        const base = this.dataset.bkSuggestUrl || '/search/suggest';
        const url =
          base +
          '.json?q=' +
          encodeURIComponent(term) +
          '&resources[type]=product,article,page' +
          '&resources[limit]=4' +
          '&resources[options][unavailable_products]=last';

        this.suggestAbort = new AbortController();
        fetch(url, { signal: this.suggestAbort.signal })
          .then((response) => (response.ok ? response.json() : Promise.reject(response.status)))
          .then((data) => this.renderSuggestions(data.resources.results, term))
          .catch((error) => {
            if (error && error.name === 'AbortError') return;
            this.clearSuggestions();
          });
      }, 220);
    }

    renderSuggestions(results, term) {
      const box = this.searchResults;
      const groups = [
        ['products', box.dataset.kindProduct],
        ['articles', box.dataset.kindArticle],
        ['pages', box.dataset.kindPage],
      ];

      box.replaceChildren();
      this.searchRows = [];
      this.searchActive = -1;

      groups.forEach(([key, kind]) => {
        const items = (results && results[key]) || [];
        if (!items.length) return;

        const title = document.createElement('p');
        title.className = 'bk-searchbar__group-title';
        title.textContent = kind;
        box.appendChild(title);

        items.forEach((item) => box.appendChild(this.suggestionRow(item, kind)));
      });

      if (!this.searchRows.length) {
        const empty = document.createElement('p');
        empty.className = 'bk-searchbar__empty';
        empty.textContent = (box.dataset.emptyText || 'No matches for “[term]”.').replace('[term]', term);
        box.appendChild(empty);
      } else {
        const all = document.createElement('a');
        all.className = 'bk-searchbar__all';
        all.href = '/search?q=' + encodeURIComponent(term);
        all.textContent = (box.dataset.allLabel || 'See all results') + ' →';
        box.appendChild(all);
      }

      box.hidden = false;
      this.searchField.setAttribute('aria-expanded', 'true');
      if (this.searchStatus) {
        this.searchStatus.textContent = this.searchRows.length
          ? this.searchRows.length + ' suggestions'
          : 'No suggestions';
      }
    }

    suggestionRow(item, kind) {
      const row = document.createElement('a');
      row.className = 'bk-searchbar__row';
      row.href = item.url;
      row.id = 'bk-search-option-' + this.searchRows.length;
      row.setAttribute('role', 'option');
      row.setAttribute('aria-selected', 'false');

      const image = item.featured_image && item.featured_image.url ? item.featured_image.url : item.image;
      if (image) {
        const thumb = document.createElement('img');
        thumb.className = 'bk-searchbar__thumb';
        thumb.src = image.replace(/(\.[a-z]+)(\?|$)/i, '_92x$1$2');
        thumb.alt = '';
        thumb.width = 46;
        thumb.height = 46;
        thumb.loading = 'lazy';
        row.appendChild(thumb);
      }

      const text = document.createElement('span');
      text.className = 'bk-searchbar__row-text';

      const title = document.createElement('span');
      title.className = 'bk-searchbar__row-title';
      title.textContent = item.title;
      text.appendChild(title);

      const label = document.createElement('span');
      label.className = 'bk-searchbar__kind';
      label.textContent = kind;
      text.appendChild(label);

      row.appendChild(text);

      /*
       * suggest.json returns price as a plain decimal string — no symbol and no
       * grouping. shop.money_format carries both, so the shop's own format wins
       * over a hard-coded dollar sign.
       */
      /*
       * suggest.json carries no metafields, so the suggestion cannot ask whether
       * a bottle is sold by inquiry. The handles come down with the markup
       * instead — a short list, and the wrong price is worse than none.
       */
      const byInquiry = (this.dataset.bkInquiryHandles || '')
        .split(',')
        .map((h) => h.trim())
        .filter(Boolean)
        .some((h) => String(item.url || '').includes(`/products/${h}`));

      if (item.price && !byInquiry) {
        const price = document.createElement('span');
        price.className = 'bk-searchbar__price';
        const format = this.dataset.bkMoneyFormat || '';
        /*
         * A price of exactly zero cents is written without them, the way
         * money_without_trailing_zeros writes it everywhere else on the site: a bottle
         * is $1,999, not $1,999.00. Real cents are kept — $19.99 stays $19.99.
         */
        const amount = String(item.price).replace(/[.,]00$/, '');
        price.textContent = format
          ? format.replace(/\{\{\s*amount[^}]*\}\}/, amount)
          : '$' + amount;
        row.appendChild(price);
      }

      this.searchRows.push(row);
      return row;
    }

    /*
     * Arrow keys walk the list without moving focus off the field, which is what
     * a combobox does: the field keeps the caret, aria-activedescendant tells a
     * screen reader which option is current.
     */
    onSearchKey(event) {
      if (event.key === 'Escape') return; // handled by onKeydown

      if (!this.searchRows.length) return;

      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        const count = this.searchRows.length;
        let next = this.searchActive + (event.key === 'ArrowDown' ? 1 : -1);
        if (next < 0) next = count - 1;
        if (next > count - 1) next = 0;
        this.setSearchActive(next);
        return;
      }

      if (event.key === 'Enter' && this.searchActive > -1) {
        event.preventDefault();
        this.searchRows[this.searchActive].click();
      }
    }

    setSearchActive(index) {
      this.searchRows.forEach((row, position) => {
        const active = position === index;
        row.classList.toggle('is-active', active);
        row.setAttribute('aria-selected', String(active));
      });

      this.searchActive = index;
      const current = this.searchRows[index];
      if (current) {
        this.searchField.setAttribute('aria-activedescendant', current.id);
        current.scrollIntoView({ block: 'nearest' });
      } else {
        this.searchField.removeAttribute('aria-activedescendant');
      }
    }

    mobileOpen() {
      return !!this.mobileNav && this.mobileNav.dataset.open === 'true';
    }

    openMobile() {
      this.closeMega();
      this.mobileNav.hidden = false;
      document.body.style.overflow = 'hidden';
      this.burger.setAttribute('aria-expanded', 'true');

      // A frame between unhiding and the state flip, or the slide never runs.
      requestAnimationFrame(() => {
        this.mobileNav.dataset.open = 'true';
        /*
         * The panel takes focus, not the search field: focusing an input opens
         * the on-screen keyboard, which would hide the menu the tap asked for.
         */
        if (this.mobilePanel) this.mobilePanel.focus();
      });
    }

    closeMobile(releaseScroll = true) {
      this.mobileNav.dataset.open = 'false';
      this.burger.setAttribute('aria-expanded', 'false');
      if (releaseScroll) document.body.style.overflow = '';

      const done = () => {
        this.mobileNav.hidden = true;
      };

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        done();
      } else {
        setTimeout(done, 350);
      }

      if (this.burger && document.contains(this.burger)) this.burger.focus();
    }

    /* Escape is handled in onKeydown; this is the focus trap only. */
    trapMobile(event) {
      if (!this.mobileOpen() || !this.mobilePanel) return;

      const focusable = this.mobilePanel.querySelectorAll(
        'a[href], button:not([disabled]), input:not([type="hidden"]), select, [tabindex]:not([tabindex="-1"])'
      );
      const visible = Array.from(focusable).filter((el) => el.offsetParent !== null);
      if (!visible.length) return;

      const first = visible[0];
      const last = visible[visible.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  }

  if (!customElements.get('bhakta-header')) {
    customElements.define('bhakta-header', BhaktaHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bhakta-hero"] && !Shopify.designMode) return;
  try {
    
  class BhaktaHero extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-bk-slide]'));
      if (!this.slides.length) return;

      this.dots = Array.from(this.querySelectorAll('[data-bk-dot]'));
      this.counter = this.querySelector('[data-bk-counter]');
      this.index = 0;

      this.querySelectorAll('[data-bk-prev]').forEach((el) =>
        el.addEventListener('click', () => this.go(this.index - 1))
      );
      this.querySelectorAll('[data-bk-next]').forEach((el) =>
        el.addEventListener('click', () => this.go(this.index + 1))
      );
      this.dots.forEach((dot) =>
        dot.addEventListener('click', () => this.go(Number(dot.dataset.index)))
      );

      this.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') this.go(this.index - 1);
        if (event.key === 'ArrowRight') this.go(this.index + 1);
      });

      this.initRail();
      this.show(0);
      this.initAutoplay();
    }

    disconnectedCallback() {
      this.stopAutoplay();
    }

    initAutoplay() {
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (this.dataset.autoplay !== 'true' || reduced || this.slides.length < 2) return;
      const interval = Number(this.dataset.interval) || 6000;
      this.timer = setInterval(() => this.go(this.index + 1), interval);
      this.addEventListener('mouseenter', () => this.stopAutoplay());
      this.addEventListener('focusin', () => this.stopAutoplay());
    }

    stopAutoplay() {
      if (this.timer) clearInterval(this.timer);
      this.timer = null;
    }

    go(next) {
      const total = this.slides.length;
      this.show((next + total) % total);
    }

    show(index) {
      this.index = index;
      this.slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('is-active', active);
        if (active) slide.removeAttribute('aria-hidden');
        else slide.setAttribute('aria-hidden', 'true');
      });
      this.dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
        dot.setAttribute('aria-pressed', String(i === index));
      });
      if (this.counter) {
        const pad = (n) => String(n).padStart(2, '0');
        this.counter.textContent = pad(index + 1) + ' / ' + pad(this.slides.length);
      }
    }

    /* Year rail — swap the big_year slide's content without a page load. */
    initRail() {
      const data = this.querySelector('[data-bk-rail-data]');
      this.railItems = Array.from(this.querySelectorAll('[data-bk-rail-item]'));
      if (!data || !this.railItems.length) return;

      try {
        this.railData = JSON.parse(data.textContent);
      } catch (error) {
        return;
      }

      this.railItems.forEach((item) => {
        item.addEventListener('click', () => this.pickYear(item.dataset.year));
      });
    }

    pickYear(year) {
      const entry = this.railData.find((row) => String(row.year) === String(year));
      if (!entry) return;

      const set = (selector, value) => {
        const el = this.querySelector(selector);
        if (el && value) el.textContent = value;
      };
      set('[data-bk-year]', entry.year);
      set('[data-bk-name]', entry.name);
      set('[data-bk-price]', entry.price);
      set('[data-bk-scarcity]', entry.scarcity);
      set('[data-bk-fact]', entry.fact);

      const image = this.querySelector('.bk-hero__bottle-img');
      if (image && entry.image) {
        image.removeAttribute('srcset');
        image.src = entry.image;
        image.alt = entry.name || '';
      }

      const primary = this.querySelector('[data-bk-primary]');
      if (primary && entry.url) primary.href = entry.url;

      this.railItems.forEach((item) => {
        const active = String(item.dataset.year) === String(year);
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });
    }
  }

  if (!customElements.get('bhakta-hero')) {
    customElements.define('bhakta-hero', BhaktaHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bhakta-quiz"] && !Shopify.designMode) return;
  try {
    
  /*
   * One state machine: step -1 is the intro, 0..total-1 the questions, total the
   * result. Nothing is fetched and nothing is destroyed — panels are unhidden.
   */
  class BhaktaQuiz extends HTMLElement {
    connectedCallback() {
      this.total = parseInt(this.dataset.total, 10) || 0;
      if (!this.total) return;

      this.intro = this.querySelector('[data-bk-panel="intro"]');
      this.questions = Array.from(this.querySelectorAll('[data-bk-panel="question"]'));
      this.tiebreak = this.querySelector('[data-bk-panel="tiebreak"]');
      this.results = Array.from(this.querySelectorAll('[data-bk-panel="result"]'));
      this.startBtn = this.querySelector('[data-bk-start]');
      this.step = -1;
      this.showContext();

      /* The start button only exists for a visitor who has the script. */
      if (this.startBtn) {
        this.startBtn.hidden = false;
        this.startBtn.addEventListener('click', () => this.go(0));
      }

      this.addEventListener('change', (event) => {
        const option = event.target.closest('[data-bk-option]');
        if (option) this.onPick();
      });

      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-bk-next]')) this.go(this.step + 1);
        if (event.target.closest('[data-bk-back]')) this.go(this.step - 1);
        if (event.target.closest('[data-bk-restart]')) this.restart();
      });

      this.render();
    }

    /*
     * ?context=birth-year or milestone: the concierge panels pass on what the
     * reader chose, and the intro repeats it back. Nothing is preselected — the
     * three questions are about taste, not occasion.
     */
    showContext() {
      const slot = this.querySelector('[data-bk-context]');
      if (!slot) return;
      const key = new URLSearchParams(window.location.search).get('context');
      const copy = {
        'birth-year': this.dataset.contextBirthYear,
        milestone: this.dataset.contextMilestone,
      }[key];
      if (!copy) return;
      slot.textContent = copy;
      slot.hidden = false;
    }

    /*
     * A pick paints the dot and releases Next, and stops there. The prototype
     * flipped to the following question after 260ms; client review, PAGE 1 asks
     * for the reader to press Next, so an answer can be read back and changed
     * before it is committed.
     */
    onPick() {
      /* On the last question the answer decides whether the tie-breaker follows, and
         therefore what the button says — so a pick re-renders rather than only
         releasing Next. */
      if (this.step === this.total - 1) this.render();
      else this.syncNav();
    }

    /*
     * The last step is the result. When the three answers land one point on each
     * journey there is a step before it: the tie-breaker, which is why `last` is
     * asked rather than assumed.
     */
    get lastStep() {
      return this.total + (this.needsTiebreak() ? 1 : 0);
    }

    go(step) {
      this.step = Math.max(-1, Math.min(step, this.lastStep));
      this.render();
    }

    restart() {
      this.querySelectorAll('[data-bk-option]').forEach((input) => {
        input.checked = false;
      });
      this.go(-1);
    }

    answerOf(index) {
      return this.questions[index].querySelector('[data-bk-option]:checked');
    }

    /* One point per answer, to the journey that answer belongs to. */
    score() {
      const score = this.results.map(() => 0);
      this.questions.forEach((_, index) => {
        const picked = this.answerOf(index);
        if (!picked) return;
        const journey = parseInt(picked.dataset.journey, 10);
        if (journey >= 0 && journey < score.length) score[journey] += 1;
      });
      return score;
    }

    /*
     * Every question answered and no journey ahead of the others: the answers point
     * three ways at once, so the reader is asked which to take first rather than being
     * handed whichever journey happened to be defined first.
     */
    needsTiebreak() {
      if (!this.tiebreak) return false;
      const answered = this.questions.every((_, index) => this.answerOf(index));
      if (!answered) return false;
      return Math.max(...this.score()) < 2;
    }

    tiebreakAnswer() {
      return this.tiebreak ? this.tiebreak.querySelector('[data-bk-option]:checked') : null;
    }

    /* A clear lead decides it; otherwise the tie-breaker does, on its own. */
    winner() {
      const score = this.score();
      const top = Math.max(...score);
      if (top >= 2) return score.indexOf(top);
      const picked = this.tiebreakAnswer();
      if (picked) {
        const journey = parseInt(picked.dataset.journey, 10);
        if (journey >= 0 && journey < score.length) return journey;
      }
      return score.indexOf(top);
    }

    panelAt(step) {
      if (step >= 0 && step < this.total) return this.questions[step];
      if (step === this.total && this.needsTiebreak()) return this.tiebreak;
      return null;
    }

    syncNav() {
      const panel = this.panelAt(this.step);
      if (!panel) return;

      const next = panel.querySelector('[data-bk-next]');
      const back = panel.querySelector('[data-bk-back]');
      const picked = panel === this.tiebreak ? this.tiebreakAnswer() : this.answerOf(this.step);
      if (next) next.disabled = !picked;
      if (back) back.hidden = this.step === 0 && !this.startBtn;

      panel.querySelectorAll('[data-bk-dot]').forEach((dot) => {
        const index = parseInt(dot.dataset.bkDot, 10);
        if (index < this.step) dot.dataset.bkState = 'done';
        else if (index === this.step) dot.dataset.bkState = 'here';
        else delete dot.dataset.bkState;
      });
    }

    render() {
      const onTiebreak = this.step === this.total && this.needsTiebreak();
      const isResult = this.step >= this.lastStep && this.step >= this.total;
      const win = isResult ? this.winner() : -1;

      this.intro.hidden = this.step !== -1;
      this.questions.forEach((panel, index) => {
        panel.hidden = index !== this.step;
      });
      if (this.tiebreak) this.tiebreak.hidden = !onTiebreak;
      this.results.forEach((panel, index) => {
        panel.hidden = index !== win;
      });

      const panel = this.panelAt(this.step);
      if (panel) {
        const next = panel.querySelector('[data-bk-next]');
        if (next && panel !== this.tiebreak) {
          /* The last question may still be followed by the tie-breaker, and which it
             is depends on the answer just given — so the label is decided here. */
          const ends = this.step === this.total - 1 && !this.needsTiebreak();
          next.innerHTML = (ends ? this.dataset.finalLabel : this.dataset.nextLabel) + ' →';
        }
        this.syncNav();

        const legend = panel.querySelector('.bk-quiz__legend');
        if (legend) legend.setAttribute('tabindex', '-1');
        if (legend && this.step >= 0) legend.focus({ preventScroll: true });
      }
    }
  }

  if (!customElements.get('bhakta-quiz')) {
    customElements.define('bhakta-quiz', BhaktaQuiz);
  }


  (() => {
    const measurementId = 'G-LVVT97XQJ8';
    const quizName = 'bhakta_concierge';
    const query = new URLSearchParams(window.location.search);
    const isPreview = () =>
      query.has('preview_theme_id') ||
      Boolean(window.Shopify && window.Shopify.designMode) ||
      Boolean(document.getElementById('PBarNextFrame'));

    const cleanText = (value) => (value || '').replace(/\s+/g, ' ').trim().slice(0, 100);

    const sendEvent = (eventName, parameters) => {
      const payload = Object.assign(
        {
          send_to: measurementId,
          quiz_name: quizName,
          tracking_version: '2026-09-28',
        },
        parameters
      );

      if (isPreview()) {
        const debugTarget = document.querySelector('bhakta-quiz');
        if (debugTarget) {
          const history = debugTarget.dataset.bkAnalyticsEvents
            ? debugTarget.dataset.bkAnalyticsEvents.split(',')
            : [];
          history.push(eventName);
          debugTarget.dataset.bkAnalyticsEvents = history.join(',');
        }
        window.bhaktaQuizTrackingDebug = window.bhaktaQuizTrackingDebug || [];
        window.bhaktaQuizTrackingDebug.push({ event: eventName, parameters: payload });
        return;
      }

      window.dataLayer = window.dataLayer || [];
      window.gtag = window.gtag || function () {
        window.dataLayer.push(arguments);
      };
      window.gtag('event', eventName, payload);
    };

    const setupQuizTracking = (quiz) => {
      if (quiz.dataset.bkAnalyticsReady === 'true') return;
      quiz.dataset.bkAnalyticsReady = 'true';

      const committedAnswers = new Map();
      const context = query.get('context') || 'direct';
      let attempt = 0;
      let resultTracked = false;

      const currentAttempt = () => Math.max(attempt, 1);

      const resultDetails = (result) => {
        const journeyIndex = parseInt(result.dataset.journey, 10);
        return {
          result_id: Number.isNaN(journeyIndex) ? 'unknown' : 'journey_' + (journeyIndex + 1),
          result_name: cleanText(result.querySelector('.bk-quiz__result-title')?.textContent),
        };
      };

      const trackAnswer = (panel) => {
        if (!panel) return;
        const answer = panel.querySelector('[data-bk-option]:checked');
        if (!answer) return;

        const isTiebreak = panel.dataset.bkPanel === 'tiebreak';
        const index = isTiebreak ? parseInt(quiz.dataset.total, 10) : parseInt(panel.dataset.index, 10);
        const questionId = isTiebreak ? 'tiebreak' : 'question_' + (index + 1);
        const answerId = answer.value || 'unknown';
        const priorAnswer = committedAnswers.get(questionId);

        if (priorAnswer === answerId) return;

        sendEvent('quiz_question_answered', {
          quiz_attempt: currentAttempt(),
          quiz_context: context,
          question_id: questionId,
          question_number: index + 1,
          question_text: cleanText(panel.querySelector('.bk-quiz__legend')?.textContent),
          answer_id: answerId,
          answer_text: cleanText(answer.closest('.bk-quiz__option')?.querySelector('.bk-quiz__label')?.textContent),
          answer_journey: 'journey_' + (parseInt(answer.dataset.journey, 10) + 1),
          answer_changed: priorAnswer !== undefined,
        });

        committedAnswers.set(questionId, answerId);
      };

      const trackResult = () => {
        const result = quiz.querySelector('[data-bk-panel="result"]:not([hidden])');
        if (!result || resultTracked) return;

        resultTracked = true;
        const details = resultDetails(result);
        const parameters = Object.assign(
          {
            quiz_attempt: currentAttempt(),
            quiz_context: context,
            question_count: parseInt(quiz.dataset.total, 10) || 0,
            questions_answered: committedAnswers.size,
            used_tiebreak: committedAnswers.has('tiebreak'),
          },
          details
        );

        sendEvent('quiz_complete', parameters);
        sendEvent('quiz_result_view', parameters);
      };

      quiz.addEventListener('click', (event) => {
        const start = event.target.closest('[data-bk-start]');
        const next = event.target.closest('[data-bk-next]');
        const restart = event.target.closest('[data-bk-restart]');
        const resultLink = event.target.closest('[data-bk-panel="result"] .bk-btn');

        if (start) {
          attempt += 1;
          resultTracked = false;
          committedAnswers.clear();
          sendEvent('quiz_start', {
            quiz_attempt: attempt,
            quiz_context: context,
            question_count: parseInt(quiz.dataset.total, 10) || 0,
          });
        }

        if (next) {
          trackAnswer(next.closest('[data-bk-panel]'));
          window.setTimeout(trackResult, 0);
        }

        if (resultLink) {
          const result = resultLink.closest('[data-bk-panel="result"]');
          const destination = new URL(resultLink.href, window.location.origin);
          sendEvent(
            'quiz_product_click',
            Object.assign(
              {
                quiz_attempt: currentAttempt(),
                quiz_context: context,
                link_text: cleanText(resultLink.textContent),
                destination_path: destination.pathname,
              },
              resultDetails(result)
            )
          );
        }

        if (restart) {
          sendEvent('quiz_restart', {
            quiz_attempt: currentAttempt(),
            quiz_context: context,
          });
          resultTracked = false;
          committedAnswers.clear();
        }
      });
    };

    document.querySelectorAll('bhakta-quiz').forEach(setupQuizTracking);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('bhakta-quiz').forEach(setupQuizTracking);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
